import { render, staticRenderFns } from "./LocalizedRouterLink.vue?vue&type=template&id=6a043621&"
import script from "./LocalizedRouterLink.vue?vue&type=script&lang=js&"
export * from "./LocalizedRouterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports